module.exports = __webpack_public_path__ + "img/PENDING.9f288401.svg";